namespace Matrix.Rebalancer {
    export namespace SummaryViewInstanceService {
        export const baseUrl = 'Rebalancer/SummaryViewInstance';

        export declare function Create(request: Serenity.SaveRequest<SummaryViewInstanceRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<SummaryViewInstanceRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<SummaryViewInstanceRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<SummaryViewInstanceRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Rebalancer/SummaryViewInstance/Create",
            Update = "Rebalancer/SummaryViewInstance/Update",
            Delete = "Rebalancer/SummaryViewInstance/Delete",
            Retrieve = "Rebalancer/SummaryViewInstance/Retrieve",
            List = "Rebalancer/SummaryViewInstance/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>SummaryViewInstanceService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
